var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-field-layout",
    {
      attrs: {
        validator: _vm.validator,
        "has-focus": _vm.hasFocus,
        "side-grid": _vm.sideGrid,
        "no-underline": "",
        "no-error-icon": "",
        radio: "",
      },
      scopedSlots: _vm._u(
        [
          {
            key: "label",
            fn: function () {
              return [
                _vm._t("label", function () {
                  return [
                    _vm.label
                      ? _c("base-label", {
                          attrs: {
                            "input-id": _vm.id,
                            label: _vm.label,
                            "hidden-label": _vm.hiddenLabel,
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "prepend-input",
            fn: function () {
              return [_vm._t("prepend-input")]
            },
            proxy: true,
          },
          {
            key: "append-input",
            fn: function () {
              return [_vm._t("append-input")]
            },
            proxy: true,
          },
          {
            key: "before-input",
            fn: function () {
              return [_vm._t("before-input")]
            },
            proxy: true,
          },
          {
            key: "after-input",
            fn: function () {
              return [_vm._t("after-input")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column" },
        _vm._l(_vm.options, function (option) {
          return _c(
            "base-radio",
            _vm._b(
              {
                key: option.value,
                staticClass: "p-default p-round",
                attrs: {
                  id: _vm.id,
                  value: _vm.valueModel,
                  "option-value": option.value,
                  disabled: option.disabled,
                  label: option.label,
                  "has-tooltip": option.hasTooltip,
                  tooltip: option.tooltip,
                  "input-type": "radio",
                },
                on: {
                  "update:value": function ($event) {
                    _vm.valueModel = $event
                  },
                  focus: _vm.handleBaseFocus,
                  blur: _vm.handleBaseBlur,
                  change: _vm.handleBaseChange,
                  input: _vm.handleBaseInput,
                },
              },
              "base-radio",
              _vm.$props,
              false
            ),
            [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
          )
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }